import type { JSX } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

interface DashboardWelcomeHeaderProps {
  title?: string;
  scroll?: boolean;
}

// Greeting-only header to show the title message passed from Dashboard index
export const DashboardWelcomeHeader = ({
  title = '',
  scroll = false
}: DashboardWelcomeHeaderProps): JSX.Element => (
  <Box component="header" sx={{ width: '100%' }}>
    <Typography
      component="h2"
      data-scroll={scroll}
      sx={{
        fontWeight: 400,
        fontSize: { xs: '32px', md: '40px' },
        lineHeight: { xs: '36px', md: '44px' },
        color: 'var(--cargill-green, #00843d)',
        letterSpacing: 0,
        m: 0,
        fontFamily:
          "var(--font-family-big-caslon, 'Big Caslon For Cargill', serif)"
      }}
    >
      {title || ''}
    </Typography>

    <Divider
      sx={{
        borderColor: 'var(--neutral-300, #dbdddc)',
        mt: '8px',
        mb: '24px'
      }}
    />
  </Box>
);